module.exports = __webpack_public_path__ + "static/img/12.1.244dea9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/eng/12.1.png
// module id = yv10
// module chunks = 0